import { SchemaType } from "../../../yaml-content";
import React from "react";
import { MdCancel, MdCheckCircle } from "react-icons/md";

type Props = {
  schemaType: SchemaType;
  componentSchemas: SchemaType[] | null;
};

const SchemaTypeTable = ({ schemaType, componentSchemas }: Props) => {
  function findSchema(ref: string | null): SchemaType | null {
    const response = componentSchemas?.find((item) => item.path === ref);
    if (response) {
      return response;
    }
    return null;
  }

  function setWidth(val: string) {
    return {
      width: val + "%",
    };
  }

  return (
    <section>
      {schemaType.properties && schemaType.properties.length > 0 && (
        <div className="sect4">
          <table className="tableblock frame-all grid-all stretch">
            <colgroup>
              <col style={setWidth("20")} />
              <col style={setWidth("10")} />
              <col style={setWidth("20")} />
              <col style={setWidth("40")} />
              <col style={setWidth("10")} />
            </colgroup>
            <thead>
              <tr>
                <th className="tableblock halign-left valign-top">
                  Field Name
                </th>
                <th className="tableblock halign-center valign-top">
                  Required
                </th>
                <th className="tableblock halign-center valign-top">Type</th>
                <th className="tableblock halign-center valign-top">
                  Description
                </th>
                <th className="tableblock halign-center valign-top">Example</th>
              </tr>
            </thead>
            <tbody>
              {schemaType.properties?.map((property, index) => {
                const required = isRequired();

                function isRequired(): boolean {
                  if (schemaType.required) {
                    const req = schemaType.required.find(
                      (item) => item === property.name,
                    );

                    if (req) {
                      return true;
                    }
                  }
                  return false;
                }

                function formatType() {
                  if (property.type) {
                    if (property.type.includes("array")) {
                      if (property.items?.type)
                        return <div>List of {property.items?.type}</div>;
                      if (property.items?.$ref) {
                        const schemaName = findSchema(property.items?.$ref)
                          ?.name;
                        return (
                          <div>
                            List of{" "}
                            <a href={`#_${schemaName}`}> {schemaName}</a>
                          </div>
                        );
                      }
                    }
                    return capitalizeFirstLetter(property.type);
                  }
                  const schemaName = findSchema(property.$ref)?.name;
                  if (schemaName) {
                    return <a href={`#_${schemaName}`}>{schemaName}</a>;
                  }

                  return "";
                }

                function capitalizeFirstLetter(value: string): string {
                  return value.charAt(0).toUpperCase() + value.slice(1);
                }

                return (
                  <tr key={index}>
                    <td className="tableblock">{property.name}</td>
                    <td className="tableblock halign-left valign-middle">
                      <div className="tableblock">
                        {required && (
                          <MdCheckCircle
                            size={18}
                            className="w-full self-center text-primary-light"
                          />
                        )}
                        {!required && (
                          <MdCancel
                            size={18}
                            className="w-full self-center text-gray-400"
                          />
                        )}
                      </div>
                    </td>
                    <td className="tableblock halign-left valign-middle">
                      {formatType()}
                    </td>
                    <td className="tableblock halign-left valign-middle">
                      {property.description}
                    </td>
                    <td className="tableblock halign-left valign-middle">
                      <div>{property.example}</div>
                      {property.enum &&
                        property.enum.map((item, index) => {
                          return <div key={index}>{item}</div>;
                        })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {schemaType.properties && schemaType.properties.length == 0 && (
        <div className="sect4">
          <table className="tableblock frame-all grid-all stretch">
            <colgroup>
              <col style={setWidth("20")} />
              <col style={setWidth("30")} />
              <col style={setWidth("40")} />
              <col style={setWidth("10")} />
            </colgroup>
            <thead>
              <tr>
                <th className="tableblock halign-center valign-top">Type</th>
                <th className="tableblock halign-center valign-top">
                  Description
                </th>
                <th className="tableblock halign-center valign-top">Example</th>
                <th className="tableblock halign-center valign-top">Format</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="">
                  <p className="centered">{schemaType.type}</p>
                </td>
                <td className="tableblock halign-left valign-top">
                  <p className="centered">{schemaType.description}</p>
                </td>
                <td className="tableblock halign-left valign-top">
                  <div className="centered">
                    <div>{schemaType.example}</div>
                    {schemaType.enum &&
                      schemaType.enum.map((item, index) => {
                        return <div key={index}>{item}</div>;
                      })}
                  </div>
                </td>
                <td className="tableblock halign-left valign-top">
                  <p className="centered">{schemaType.format}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
export default SchemaTypeTable;
